import type { FC, ReactNode } from 'react';
import { Icon, type IconProps } from '../Icon/Icon';
import type { IconGlyph } from '../Icon/IconGlyph';
import { Tooltip, type TooltipProps } from './Tooltip';

export type TooltipIconSize = 'xs' | 'sm' | 'base' | 'lg';

type TooltipIconProps = {
  className?: string;
  size?: TooltipIconSize;
  content?: ReactNode;
  headline?: string;
  interactive?: boolean;
  tooltipProps?: Omit<TooltipProps, 'content' | 'headline' | 'interactive'>;
  iconProps?: Omit<Partial<IconProps>, 'size' | 'className'>;
  icon?: IconGlyph;
};

export const TooltipIcon: FC<TooltipIconProps> = ({
  className,
  size = 'base',
  tooltipProps,
  iconProps,
  icon = 'fa-circle-question',
  ...otherProps
}) => (
  <Tooltip {...tooltipProps} {...otherProps}>
    <Icon
      glyph={icon}
      size={size}
      className={className}
      role='img'
      aria-label='Help icon'
      {...iconProps}
    />
  </Tooltip>
);
